import {
    SET_LOGIN_INFORMATION,
    SET_SESSION_INFORMATION,
    SET_REFUSAL,
    SET_ATTEMPT_ERROR,
    SET_SESSION,
    SET_SSO_READY,
    RESET_AUTH,
} from '../actions/authentication';

// loginInformations: current challenge context (no challenge value ever stored here);
// refusal: {kind, message} replacing the form; attemptError: wrong answer, the form stays;
// session: signed-in state {mode, displayName} | null (single source, see auth/session.js).
export const initialState = {
    session: null,
    ssoReady: false,
    loginInformations: undefined,
    sessionInformation: undefined,
    refusal: null,
    attemptError: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_LOGIN_INFORMATION:
            return { ...state, loginInformations: action.data };
        case SET_SESSION_INFORMATION:
            return { ...state, sessionInformation: action.data };
        case SET_REFUSAL:
            return { ...state, refusal: action.data };
        case SET_ATTEMPT_ERROR: {
            const attemptError = action.data;
            // Keep the displayed attempt counter in sync with the server's answer.
            const loginInformations = attemptError && state.loginInformations && typeof attemptError.remaining === 'number'
                ? { ...state.loginInformations, countAttemps: attemptError.remaining }
                : state.loginInformations;
            return { ...state, attemptError, loginInformations };
        }
        case SET_SESSION:
            return { ...state, session: action.data, loginInformations: undefined, refusal: null, attemptError: null };
        case SET_SSO_READY:
            return { ...state, ssoReady: true };
        case RESET_AUTH:
            // Empties the whole slice, session included; only the SSO-check flag survives.
            return { ...initialState, ssoReady: state.ssoReady };
        default:
            return state;
    }
};
